import Axios, { type AxiosInstance } from 'axios';
import { configAxios, configAxiosAlly } from '../../config/api';

const skyAlertAPI: AxiosInstance = Axios.create(configAxios);

const skyAlertAllyAPI: AxiosInstance = Axios.create(configAxiosAlly);

export { skyAlertAPI, skyAlertAllyAPI };
